"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCameraPresenterSources = void 0;
exports.getCameraSources = getCameraSources;
exports.getMediaSourceValueObject = void 0;
exports.getSourceValue = getSourceValue;
exports.getVideoSourcesFromProgram = getVideoSourcesFromProgram;
exports.isScreenShareOnStage = isScreenShareOnStage;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Sources = require("@studio/constants/Sources");
var _checkSourceTypes = require("./checkSourceTypes");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getCameraSources(sources) {
  return sources.filter(function (source) {
    return (source === null || source === void 0 ? void 0 : source.type) === _Sources.CAMERA_PRESENTER;
  });
}

/**
 * Gets all video sources (cameras AND screen shares) from the program
 * @param {Object} program - The program object containing layers
 * @returns {Array} Array of source values (attendee IDs)
 */
function getVideoSourcesFromProgram(program) {
  var _program$layers$map$f, _program$layers;
  var programSources = (_program$layers$map$f = program === null || program === void 0 || (_program$layers = program.layers) === null || _program$layers === void 0 ? void 0 : _program$layers.map(function (layer) {
    return layer === null || layer === void 0 ? void 0 : layer.source;
  }).filter(Boolean)) !== null && _program$layers$map$f !== void 0 ? _program$layers$map$f : [];
  var videoSources = programSources.filter(function (source) {
    return ((source === null || source === void 0 ? void 0 : source.type) === _Sources.CAMERA_PRESENTER || (source === null || source === void 0 ? void 0 : source.type) === _Sources.SCREEN_PRESENTER) && (source === null || source === void 0 ? void 0 : source.value) !== _Sources.UNASSIGNED;
  }).map(function (src) {
    return src.value;
  });
  return videoSources;
}

/**
 * Checks whether a screen share is on stage (in the program layers)
 * @param {Object} program - The program object containing layers
 * @param {string} screenShareAttendeeId - The screen share attendee ID (`<attendeeId>#content`)
 * @returns {boolean} True when the screen share is in the program
 */
function isScreenShareOnStage(program, screenShareAttendeeId) {
  return getVideoSourcesFromProgram(program).includes(screenShareAttendeeId);
}

/**
 * Get an object value even when the value is in "legacy" format for media sources (used to be just the event doc ID)
 * @param {*} value
 */
var getMediaSourceValueObject = exports.getMediaSourceValueObject = function getMediaSourceValueObject(value) {
  return typeof value === 'string' ? {
    eventDocId: value
  } : value;
};

/**
 * @description Returns a source value. if the value is unassigned,
 * it returns a concatenated value with the source id
 * @param {Object} source
 * @returns String
 */
function getSourceValue(source) {
  var sourceValue = source.value;
  if (sourceValue === _Sources.UNASSIGNED) {
    sourceValue = "".concat(_Sources.UNASSIGNED, "-").concat(source._id);
  }
  return sourceValue;
}

/**
 * @description Will return an array of indexed camera presenter sources
 *
 * @param layers
 */
var getCameraPresenterSources = exports.getCameraPresenterSources = function getCameraPresenterSources(layers) {
  return (layers === null || layers === void 0 ? void 0 : layers.reduce(function (accumulator, layer) {
    if ((0, _checkSourceTypes.isCameraPresenter)(layer.source)) {
      accumulator[layer._id] = layer.source;
      return accumulator;
    }
    return _objectSpread({}, accumulator);
  }, {})) || {};
};